// Tiny waveform helper: peaks from an AudioBuffer + draw to a canvas. License-free
// (no wavesurfer dep) since the engine already decodes the buffers.

export function computePeaks(buffer, samples) {
  if (!buffer) return [];
  const data = buffer.getChannelData(0);
  const block = Math.max(1, Math.floor(data.length / samples));
  const peaks = [];
  for (let i = 0; i < samples; i++) {
    let max = 0;
    const s = i * block;
    for (let j = 0; j < block; j++) {
      const v = Math.abs(data[s + j] || 0);
      if (v > max) max = v;
    }
    peaks.push(max);
  }
  return peaks;
}

export function drawWaveform(canvas, peaks, color) {
  if (!canvas) return;
  const ctx = canvas.getContext("2d");
  const w = canvas.width, h = canvas.height;
  ctx.clearRect(0, 0, w, h);
  if (!peaks.length) return;
  ctx.fillStyle = color;
  const bw = w / peaks.length;
  for (let i = 0; i < peaks.length; i++) {
    const ph = Math.max(1, peaks[i] * h * 0.9);
    ctx.fillRect(i * bw, (h - ph) / 2, Math.max(1, bw - 0.4), ph);
  }
}
